import { OrderItem, Voucher } from '../orders/model';
import { RegistrationOptionInput } from '../registration/model';
import { BadgeData, BadgeDesign } from './badgeDesign';
import { BaseUser, UserRegistration } from './base';

export type CashierStatus = 'complete' | 'error' | 'ok' | 'warning';

export type LicenseWarnings = 'dobMismatch' | 'expired' | 'firstNameMismatch' | 'lastNameMismatch';

export interface CashierBadgeData {
  design: BadgeDesign;
  labels: BadgeData[];
  extraLabels: ExtraLabel[];
  nfc?: NFCBadgeInfo;
}

interface ExtraLabel {
  design: BadgeDesign;
  labels: BadgeData;
}

export interface UndeliveredProducts extends OrderItem {
  orderId: number;
}

export const enum CashierInfo {
  ReturningAttendee,
  VouchersApplied,
  NoBarcodeScanned,
  UserIsDealer,
}

export const enum CashierError {
  UnderReview,
  Banned,
  ItemsPendingPayment,
  NotRegistered,
  NoPaidRegistration,
  ProductTypeAgeViolation,
  NoBarcodeScanned,
  OutstandingBalance,
}

export const enum CashierWarning {
  Minor,
  Volunteer,
  BannedWordUsage,
  Guardian,
  OutstandingDealerPayment,
}

export interface CashierNote<T extends number> {
  code: T;
  args?: (number | string | null)[];
}

export interface CashierCheck {
  bannedWords: string[];
  dueBalance: number;
  errors: CashierNote<CashierError>[];
  info: CashierNote<CashierInfo>[];
  warnings: CashierNote<CashierWarning>[];
  notes: string[];
  status: CashierStatus;
  user: BaseUser;
  isMinor: boolean;
  dueItems: Record<string, number>;
  vouchers: Voucher[];
  registration?: UserRegistration;
  badge?: CashierBadgeData;
  undeliveredProducts: UndeliveredProducts[];
  cashierCheckIn: boolean;
  regOptions: RegistrationOptionInput[];

  licenseWarnings: LicenseWarnings[];
  scannedInformation?: ScannedUserInformation;
}

export interface NFCSignedContent {
  userId: number;
  conventionId: number;
  issuanceCount: number;
  timestamp: string;
}
export interface NFCBadge {
  password: number;
  signedContent: NFCSignedContent;
  signature: string;
}

export interface NFCPassword {
  password: number;
}

interface NFCBadgeInfo {
  UUID: string;
}

export interface ScannedUserInformation {
  firstName?: string;
  lastName?: string;
  bornAt: Date | null;
}
